export default "__VITE_ASSET__Ci1U0gVq__"